// Footstep visualization: when the player makes noise, spawn a ring on the
// ground at their feet. The ring expands and fades — the seeker AI doesn't
// need this (it uses noiseLevel directly), but the seeker player view shows it
// as a diegetic cue ("ripples in the dust").

import * as THREE from 'three';

export class FootstepRipples {
  constructor(scene, planet) {
    this.scene = scene;
    this.planet = planet;
    this.pool = [];
    this.active = [];
    this.geo = new THREE.RingGeometry(0.4, 0.5, 24);
  }

  _make() {
    const mat = new THREE.ShaderMaterial({
      uniforms: { uAge: { value: 0 }, uColor: { value: new THREE.Color(0xffd285) } },
      vertexShader: `varying vec2 vUv;
        void main() { vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`,
      fragmentShader: `uniform float uAge; uniform vec3 uColor; varying vec2 vUv;
        void main() {
          float a = (1.0 - uAge);
          gl_FragColor = vec4(uColor, a * 0.7);
        }`,
      transparent: true, depthWrite: false, side: THREE.DoubleSide,
      blending: THREE.AdditiveBlending,
    });
    const m = new THREE.Mesh(this.geo, mat);
    return m;
  }

  spawn(dir, intensity = 0.5) {
    let m = this.pool.pop();
    if (!m) m = this._make();
    const r = this.planet.sampleRadius(dir);
    m.position.copy(dir).multiplyScalar(r + 0.05);
    m.quaternion.setFromUnitVectors(new THREE.Vector3(0, 0, 1), dir.clone().normalize());
    m.material.uniforms.uAge.value = 0;
    m.material.uniforms.uColor.value.setHSL(0.12, 0.7, 0.6 + intensity * 0.2);
    m.userData.life = 1.4;
    m.userData.age = 0;
    m.userData.intensity = intensity;
    m.scale.setScalar(0.2);
    this.scene.add(m);
    this.active.push(m);
  }

  update(dt) {
    for (let i = this.active.length - 1; i >= 0; i--) {
      const m = this.active[i];
      m.userData.age += dt;
      const t = m.userData.age / m.userData.life;
      m.material.uniforms.uAge.value = t;
      m.scale.setScalar(0.2 + t * (1.5 + m.userData.intensity * 1.5));
      if (t >= 1) {
        this.scene.remove(m);
        this.active.splice(i, 1);
        this.pool.push(m);
      }
    }
  }
}
